import config from "config";
import _ from "lodash";
import localeService from "services/localeService";
import ViewModel from "viewModels/ViewModel";
import ko from "knockout";

const JOURNEY_BASE_URL = config.journey.uri;
const JOURNEY_BASE_URL_HAWK = config.journey_micro.uri;
const JOURNEY_PURECLOUD_LAUNCHER_WIDGET_PATH_HAWK =
    "/gpe-ui-holistic-customer-journey/#/sessions";
const CUSTOMER_JOURNEY_FRAME_SELECTOR = // TODO: do this in an onload event handler instead
    "iframe.customer-journey-details__iframe";

/**
 * @param  {function} callback returned if origins are the same and is specified
 * @param  {function} fallback returned if origins are not the same and is specified
 * @returns {function} callback, fallback, or _.noop
 */
const whenOriginsMatch = function (callback, fallback) {
    const baseOrigin = (JOURNEY_BASE_URL || JOURNEY_BASE_URL_HAWK)
        .split("/")
        .slice(0, -1)
        .join("/");
    if (window.origin === baseOrigin) {
        return _.isFunction(callback) ? callback : _.noop;
    }
    return _.isFunction(fallback) ? fallback : _.noop;
};

export default ViewModel.extend(function CustomerJourneyView(
    journeyContext,
    navigateToJourneys
) {
    const self = this;
    const appLocale = localeService.getAppLocale();

    const externalContactId = journeyContext.externalContactId;

    const sharedQueryParams = [
        ["locale", appLocale],
        ["timezone", ko.i18n.getTimezone()],
    ];

    const hcjHawkQueryParams = [["externalContactId", externalContactId]];

    sharedQueryParams.push(...hcjHawkQueryParams);

    const hcjQueryString = _.reduce(
        sharedQueryParams,
        function (queryAccumulator, queryKeyValue) {
            const queryKey = queryKeyValue[0];
            const queryValue = queryKeyValue[1];
            const queryComponent =
                encodeURIComponent(queryKey) +
                "=" +
                encodeURIComponent(queryValue);
            return queryAccumulator === "?"
                ? queryAccumulator + queryComponent
                : queryAccumulator + "&" + queryComponent;
        },
        "?"
    );

    self.journeyUrl =
        JOURNEY_BASE_URL_HAWK +
        JOURNEY_PURECLOUD_LAUNCHER_WIDGET_PATH_HAWK +
        hcjQueryString;

    self.navigateToJourneys = navigateToJourneys;

    // sets journey frame element height to its inner document scrollHeight
    // TODO: turn resizeJourneyFrame, handleLoaded, and onDispose into a reusable abstraction
    self.resizeJourneyFrame = whenOriginsMatch(function () {
        const journeyFrame = document.querySelector(
            CUSTOMER_JOURNEY_FRAME_SELECTOR
        );
        const journeyDocument = journeyFrame.contentDocument;
        const oldHeight = journeyFrame.scrollHeight;
        const journeyFrameBorderWidth = journeyFrame.offsetHeight - oldHeight;
        const newHeight =
            journeyDocument.getElementsByTagName("iframe")[0].contentDocument
                .body.scrollHeight + journeyFrameBorderWidth;
        if (newHeight !== oldHeight) {
            journeyFrame.style.height = newHeight + "px";
        }
    });

    // called when the DOMContentLoaded fires for the journey frame
    // cannot add resize listener unless origins match due to same-origin policy.
    self.handleLoaded = whenOriginsMatch(function () {
        const journeyFrame = document.querySelector(
            CUSTOMER_JOURNEY_FRAME_SELECTOR
        );
        journeyFrame.contentWindow.addEventListener(
            "resize",
            self.resizeJourneyFrame
        );
    });

    self.onDispose = whenOriginsMatch(function () {
        const journeyFrame = document.querySelector(
            CUSTOMER_JOURNEY_FRAME_SELECTOR
        );
        journeyFrame.contentWindow.removeEventListener(
            "resize",
            self.resizeJourneyFrame
        );
    });
});
